import get from 'lodash/get';

import {
  CLEAR_CHATS_REQUESTED,
  DROP_MESSAGES,
  GET_CHATS_SUCCESS,
  GET_CHAT_BY_ID_SUCCESS,
  GET_CHAT_INFO_BY_ID_SUCCESS,
  GET_DOCUMENT_SUCCESS,
  GET_THREADS_SCOPES_SUCCESS,
  MARK_CHAT_AS_READ_SUCCESS,
  SET_CURRENT_CHAT_ID,
  SET_DOCUMENT_AS_ATTACHMENT,
  SET_NEW_MESSAGE_TEXT,
  SET_NEW_SELECT_VALUE,
} from '../actionConstants';

import { getUniqueValues } from '../utils';

const defaultState = {
  count: 0,
  next: {},
  previous: {},
  results: [],
  currentChat: {},
  currentChatId: null,
  selectValue: {},
  newMessage: {
    documentId: null,
    documentName: null,
    text: null,
  },
  imgPreviewUrl: {},
  threadsScopes: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_CHATS_SUCCESS: {
      let results = [...state.results, ...get(action, 'payload.data.results')];
      if (action.withReset) {
        results = get(action, 'payload.data.results');
      }
      const uniqueValues = getUniqueValues(results, 'id');
      uniqueValues.sort(
        (a, b) => Date.parse(b.updatedAt) - Date.parse(a.updatedAt),
      );
      return {
        ...state,
        count: get(action, 'payload.data.count'),
        next: get(action, 'payload.data.next'),
        previous: get(action, 'payload.data.previous'),
        results: uniqueValues,
      };
    }
    case GET_CHAT_INFO_BY_ID_SUCCESS: {
      const { chatId } = action;
      const chatData = get(action, 'res.data.results');
      const chatIndex = state.results.findIndex((chat) => chat.id === chatId);
      let results = [];
      if (chatIndex) {
        results = [
          ...state.results.filter((chat) => chat.id !== chatId),
          ...chatData,
        ];
      } else {
        results = [...state.results, ...chatData];
      }
      const uniqueValues = getUniqueValues(results, 'id');
      uniqueValues.sort(
        (a, b) => Date.parse(b.updatedAt) - Date.parse(a.updatedAt),
      );

      return {
        ...state,
        results: uniqueValues,
      };
    }
    case MARK_CHAT_AS_READ_SUCCESS: {
      const updatedChat = state.results.filter(
        (chat) => action.payload === chat.id,
      )[0];
      if (!updatedChat) return state;
      updatedChat.hasUpdates = false;

      const chats = [
        updatedChat,
        ...state.results.filter((chat) => action.payload !== chat.id),
      ];
      chats.sort((a, b) => {
        const dateA = new Date(get(a, 'updatedAt', 0));
        const dateB = new Date(get(b, 'updatedAt', 0));
        return dateB - dateA;
      });

      return {
        ...state,
        results: chats,
      };
    }
    case GET_CHAT_BY_ID_SUCCESS: {
      const newItems = action?.payload?.data?.results;
      const prevItems = state?.currentChat?.results ?? [];
      return {
        ...state,
        currentChat: {
          ...action?.payload?.data,
          results: [...prevItems, ...newItems],
        },
      };
    }

    case SET_CURRENT_CHAT_ID:
      return {
        ...state,
        currentChatId: action.id,
      };
    case SET_NEW_SELECT_VALUE:
      return {
        ...state,
        selectValue: action.value,
      };
    case CLEAR_CHATS_REQUESTED:
      return {
        ...state,
        count: null,
        next: null,
        previous: null,
        results: [],
      };
    case SET_DOCUMENT_AS_ATTACHMENT:
      return {
        ...state,
        newMessage: {
          ...state.newMessage,
          documentId: action.documentId,
          documentName: action.documentName,
        },
      };
    case SET_NEW_MESSAGE_TEXT:
      return {
        ...state,
        newMessage: {
          ...state.newMessage,
          text: action.text,
        },
      };
    case GET_DOCUMENT_SUCCESS: {
      const { res } = action;
      const documentId = res?.data?.id;
      const imgUrl = res?.data?.type?.includes('image') && res?.data?.url;
      if (!documentId || !imgUrl) {
        return state;
      }
      return {
        ...state,
        imgPreviewUrl: {
          ...state.imgPreviewUrl,
          [documentId]: imgUrl,
        },
      };
    }

    case DROP_MESSAGES:
      return {
        ...state,
        currentChat: {},
        currentChatId: null, // is it used?
      };

    case GET_THREADS_SCOPES_SUCCESS:
      return {
        ...state,
        threadsScopes: action.res.data,
      };

    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        currentChatId: null,
        currentChat: {},
        newMessage: {
          documentId: null,
          documentName: null,
          text: null,
        },
        imgPreviewUrl: {},
      };
    default:
      return state;
  }
};
